export const environment = {
  production: true,
  preprod: false,
  development: false,
  apiUrl: "https://eapi.geminisolutions.com",
};
